"use client";

import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import styles from "./styles.module.css";

const AlertDialog = ({
  open,
  setOpen,
  title,
  description,
  children,
  body,
  className,
}) => {
  return (
    <Dialog open={open} setOpen={setOpen}>
      <DialogContent className={`${styles.alertDialog} ${className || ""}`}>
        <DialogHeader>
          <DialogTitle className={styles.alertTitle}>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className={styles.alertDescription}>{description}</p>
          <div className={styles.alertContent}>{body}</div>
        </DialogBody>
        <DialogFooter className={styles.alertFooter}>{children}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AlertDialog;
